import {
	ICreateJurisdictionRequestData,
	IEditJurisdictionRequestData,
	IGetJurisdictionsListRequestData,
	IGetJurisdictionsResponse,
	IGetJurisdictionsResponseData
} from "../../types";
import { getAPIHeaderOptions, transformErrorResponse } from "../../utils/apiUtils";
import { queries } from "./queries.reducer";

const jurisdictions = queries.injectEndpoints({
	endpoints: (builder) => ({
		// GET JURISDICTIONS LIST
		getJurisdictionsList: builder.query<IGetJurisdictionsResponse, IGetJurisdictionsListRequestData>({
			query: (requestData) => ({
				url: "/devices/mtes/jurisdictions/",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			}),
			transformResponse: (baseQueryReturnValue: IGetJurisdictionsResponse | IGetJurisdictionsResponseData[]) => {
				if (Array.isArray(baseQueryReturnValue)) {
					return {
						count: baseQueryReturnValue.length,
						next: null,
						previous: null,
						results: baseQueryReturnValue
					};
				}
				return baseQueryReturnValue;
			}
		}),

		// CREATE JURISDICTION
		createJurisdiction: builder.mutation<IGetJurisdictionsResponseData, ICreateJurisdictionRequestData>({
			query: (requestData) => ({
				url: "/devices/mtes/jurisdictions/",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// EDIT JURISDICTION
		editJurisdiction: builder.mutation<IGetJurisdictionsResponseData, IEditJurisdictionRequestData>({
			query: (requestData) => ({
				url: `/devices/mtes/jurisdictions/${requestData.id}/`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData.data
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// DELETE JURISDICTION
		deleteJurisdiction: builder.mutation<unknown, number>({
			query: (jurisdictionId) => ({
				url: `/devices/mtes/jurisdictions/${jurisdictionId}/`,
				headers: getAPIHeaderOptions(true),
				method: "DELETE"
			}),
			transformErrorResponse: transformErrorResponse
		})
	})
});

export const {
	// GET JURISDICTIONS LIST
	useGetJurisdictionsListQuery,
	// CREATE JURISDICTION
	useCreateJurisdictionMutation,
	// EDIT JURISDICTION
	useEditJurisdictionMutation,
	// DELETE JURISDICTION
	useDeleteJurisdictionMutation
} = jurisdictions;
